import { Box, Typography, Grid } from "@material-ui/core";

import { ShaDowBox } from "../../../../../components/boxes";
import { Icon } from "../../../../../components/base";
import CentralWithSubImg from "../../../../../assets/images/icons/central-with-sub.svg";
import SubMeterAndPublicImg from "../../../../../assets/images/icons/sub-meter-and-public.svg";

export const CentralMeterWithSubMeters = () => {

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: "24px 24px 64px" }}>
        <Typography variant="h4">Central meter, with sub-meters</Typography>
        <Grid container style={{ marginTop: 50 }}>
          <Grid item sm={6} style={{ borderRight: "1px solid rgba(88, 88, 88, 0.25)", paddingBottom: 20 }}>
            <Icon
              src={CentralWithSubImg}
              style={{
                display: "block",
                margin: "0 auto 30px",
              }}
            />
            <Grid container justifyContent="center" alignItems="baseline">
              <Typography style={{ marginRight: 5 }}>Total</Typography>
              <Typography variant="h2">80</Typography>
            </Grid>
            <Typography style={{ textAlign: "center" }}>Sub-Meters</Typography>
          </Grid>
          <Grid item sm={6} justifyContent="center" style={{ paddingBottom: 20 }}>
            <Icon
              src={SubMeterAndPublicImg}
              style={{
                display: "block",
                margin: "0 auto 30px",
              }}
            />
            <Typography style={{ textAlign: "center", fontWeight: 700 }}>
              75 submeters + 5 Public
            </Typography>
            <Typography style={{ textAlign: "center" }}>
              owner by PMC
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  )
}
